// import React, { useState } from "react";
// import {
//   TextField,
//   Button,
//   Grid,
//   Typography,
//   Box,
//   Snackbar,
//   MenuItem,
//   FormControlLabel,
//   Checkbox,
// } from "@mui/material";

// const AddBibleSurvey = () => {
//   const API_URL = process.env.REACT_APP_API_URL;

//   const [formData, setFormData] = useState({
//     bookId: "",
//     bookName: "",
//     bookNameAm: "",
//     testament: "old",
//     language: "amharic",
//     content: "",
//     provider: "",
//     model: "",
//     contributor: "",
//     verified: false,
//   });

//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.bookId || !formData.bookName || !formData.content) {
//       setError("Required fields missing");
//       return;
//     }

//     let contentObj = {};

//     try {
//       contentObj = JSON.parse(formData.content);
//     } catch {
//       setError("Invalid JSON content");
//       return;
//     }

//     try {
//       const res = await fetch(`${API_URL}/bible-surveys/push`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           language: formData.language,
//           content: contentObj,
//           provider: formData.provider,
//           model: formData.model,
//           contributor: formData.contributor,
//           verified: formData.verified,
//         }),
//       });

//       const result = await res.json();

//       if (res.ok) {
//         setSuccess("Bible Survey saved successfully");

//         setFormData({
//           bookId: "",
//           bookName: "",
//           bookNameAm: "",
//           testament: "old",
//           language: "amharic",
//           content: "",
//           provider: "",
//           model: "",
//           contributor: "",
//           verified: false,
//         });
//       } else {
//         setError(result.message);
//       }
//     } catch (err) {
//       setError("Server error");
//     }
//   };

//   return (
//     <Box sx={{ padding: 3 }}>
//       <Typography variant="h4">Add Bible Survey</Typography>

//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Book ID"
//               name="bookId"
//               value={formData.bookId}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Book Name"
//               name="bookName"
//               value={formData.bookName}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Book Name Amharic"
//               name="bookNameAm"
//               value={formData.bookNameAm}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               select
//               label="Testament"
//               name="testament"
//               value={formData.testament}
//               onChange={handleChange}
//               fullWidth
//             >
//               <MenuItem value="old">Old Testament</MenuItem>
//               <MenuItem value="new">New Testament</MenuItem>
//             </TextField>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Language"
//               name="language"
//               value={formData.language}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Provider"
//               name="provider"
//               value={formData.provider}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Model"
//               name="model"
//               value={formData.model}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Contributor"
//               name="contributor"
//               value={formData.contributor}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <TextField
//               label="Content JSON"
//               name="content"
//               value={formData.content}
//               onChange={handleChange}
//               fullWidth
//               multiline
//               rows={12}
//               required
//               placeholder={`{
//   "book": "Genesis",
//   "bookAm": "ዘፍጥረት",
//   "testament": "old",
//   "markdown": "",
//   "sections": {
//     "author": "Moses",
//     "date": "1445 BC"
//   }
// }`}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.verified}
//                   onChange={handleChange}
//                   name="verified"
//                 />
//               }
//               label="Verified"
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <Button type="submit" variant="contained">
//               Save Bible Survey
//             </Button>
//           </Grid>
//         </Grid>
//       </form>

//       <Snackbar open={!!error} message={error} onClose={() => setError(null)} />

//       <Snackbar
//         open={!!success}
//         message={success}
//         onClose={() => setSuccess(null)}
//       />
//     </Box>
//   );
// };

// export default AddBibleSurvey;

import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const AddBibleSurvey = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    bookId: "",
    language: "amharic",
    contributor: "",
    content: "",
    forceRefresh: true,
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ===================== GENERATE AI =====================
  const handleGenerate = async () => {
    if (!formData.bookId) {
      setError("Book ID is required");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${API_URL}/bible-survey/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bookId: formData.bookId,
          language: formData.language,
          forceRefresh: formData.forceRefresh,
        }),
      });

      const result = await res.json();

      if (result.success) {
        setSuccess(
          result.cached ? "Loaded from cache" : "AI Generated successfully",
        );

        setFormData((prev) => ({
          ...prev,
          content: JSON.stringify(result.data.content, null, 2),
        }));
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Generation failed");
    } finally {
      setLoading(false);
    }
  };

  // ===================== SAVE / PUSH EDIT =====================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.bookId || !formData.content) {
      setError("BookId and Content are required");
      return;
    }

    let contentObj = {};

    try {
      contentObj = JSON.parse(formData.content);
    } catch {
      setError("Invalid JSON content");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/bible-survey/push`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bookId: formData.bookId,
          language: formData.language,
          content: contentObj,
          contributor: formData.contributor,
        }),
      });

      const result = await res.json();

      if (result.success) {
        setSuccess("Saved successfully");

        setFormData({
          bookId: "",
          language: "amharic",
          contributor: "",
          content: "",
          forceRefresh: true,
        });
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Server error");
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4">Bible Survey Generator & Editor</Typography>

      {/* ================= GENERATE SECTION ================= */}
      <Box sx={{ mt: 3, mb: 3 }}>
        <Typography variant="h6">Generate AI Content</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Book ID"
              name="bookId"
              value={formData.bookId}
              onChange={handleChange}
              fullWidth
              placeholder="jude"
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Language"
              name="language"
              value={formData.language}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleGenerate}
              disabled={loading}
            >
              {loading ? "Generating..." : "Generate AI"}
            </Button>
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.forceRefresh}
                  onChange={handleChange}
                  name="forceRefresh"
                />
              }
              label="Force Refresh AI"
            />
          </Grid>
        </Grid>
      </Box>

      {/* ================= EDIT / SAVE SECTION ================= */}
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Book ID"
              name="bookId"
              value={formData.bookId}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Language"
              name="language"
              value={formData.language}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Contributor"
              name="contributor"
              value={formData.contributor}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Content JSON"
              name="content"
              value={formData.content}
              onChange={handleChange}
              fullWidth
              multiline
              rows={18}
              required
              placeholder={`{ "sections": {}, "markdown": "" }`}
            />
          </Grid>

          <Grid item xs={12}>
            <Button type="submit" variant="contained">
              Save Survey
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* ================= SNACKBAR ================= */}
      <Snackbar
        open={!!error}
        message={error}
        onClose={() => setError(null)}
        autoHideDuration={4000}
      />

      <Snackbar
        open={!!success}
        message={success}
        onClose={() => setSuccess(null)}
        autoHideDuration={4000}
      />
    </Box>
  );
};

export default AddBibleSurvey;
